var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cards"}},[_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }